import { Box, Button, ButtonProps, Flex, VStack } from "@chakra-ui/react"
import { MouseEventHandler } from "react"

const BuyNowButton = ({
  total,
  handleCart,
  ...props
}: {
  total: number
  handleCart: MouseEventHandler<HTMLButtonElement> | undefined
} & ButtonProps) => {
  const amount = total.toFixed(2).split(".")

  return (
    <Button
      color={"black"}
      size={"lg"}
      w={"100%"}
      h={16}
      borderRadius={8}
      fontSize={"xl"}
      fontWeight={700}
      shadow={"lg"}
      bgColor={"yellow.400"}
      _hover={{
        bgColor: "yellow.500",
      }}
      _active={{
        bgColor: "yellow.500",
      }}
      onClick={handleCart}
      {...props}
    >
      <Flex
        justifyContent={"space-between"}
        alignItems={"center"}
        w={"full"}
      >
        <Box>{"Add to Cart"}</Box>
        <VStack
          spacing={0}
          align={"end"}
        >
          <Flex
            alignItems={"flex-start"}
            p={0}
          >
            <Box
              mt={1}
              fontSize={"lg"}
            >
              {"AED"}
            </Box>
            <Box
              fontSize={"4xl"}
              ms={1}
            >
              {Number(amount[0]).toLocaleString()}
            </Box>
            <Box
              mt={1}
              ms={1}
              fontSize={"lg"}
            >
              {amount[1]}
            </Box>
          </Flex>
          <Box
            fontSize={"xs"}
            fontWeight={500}
            mt={-2}
          >
            {"Prices Inclusive of VAT"}
          </Box>
        </VStack>
      </Flex>
    </Button>
  )
}

export default BuyNowButton
